// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'mark... Remove this comment to see the full error message
import BaseApp from 'marketplace-assets-base/App';
import rhumbConfig from '../rhumb-config.yaml';
export default class App extends BaseApp {
  getAppName() {
    return 'marketplace-assets-app-ui';
  }
  getRhumbConfig() {
    return rhumbConfig;
  }
}